import { render, staticRenderFns } from "./employment-roles.vue?vue&type=template&id=09f4b30a&"
import script from "./employment-roles.vue?vue&type=script&lang=js&"
export * from "./employment-roles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports